import ElmModal from "../elm_modal"
import { logDecodingError } from "../../helpers/airbrake"

export const setupVenueModals = (elmVenue: ElmVenue): void => {
  const modal = new ElmModal({ containerId: "elm-shared-modal-container" })

  document.querySelectorAll<HTMLElement>(".elm-shared-modal-button").forEach(button => {
    const flags = JSON.parse(button.dataset.elmFlags || "{}")

    button.removeAttribute("data-elm-flags")
    button.addEventListener("click", (e : Event) => {
      e.preventDefault()

      const node = modal.node()
      const app = elmVenue.Modal.init({ node, flags })

      app.ports.modalOpened.subscribe(modal.trapFocus)
      app.ports.flagDecodingError.subscribe(() => logDecodingError(flags))
    })
  })
}
